import type { App, DirectiveBinding } from 'vue'
import { isGlobal } from '@/utils/constant'

const throttleClickListener = (el: HTMLElement, delay = 2500) => {
  return () => {
    el.style.pointerEvents = 'none'
    setTimeout(() => {
      if (el?.style) el.style.pointerEvents = 'auto'
    }, delay)
  }
}

// 按钮防抖指令
const initThrottle = (app: App<Element>) => {
  app.directive('throttle', {
    async mounted(
      el: HTMLElement,
      binding: DirectiveBinding<string | string[]>,
    ) {
      el.addEventListener(
        'click',
        throttleClickListener(el, binding.value as unknown as number),
      )
    },
    unmounted(el: HTMLElement) {
      el.removeEventListener('click', throttleClickListener(el))
    },
  })
}

const toggleGlobalHidden = (
  el: HTMLElement,
  binding: DirectiveBinding<boolean>,
) => {
  if (!isGlobal) return

  const shouldHide = binding?.value ?? true

  if (shouldHide) {
    if (!el.dataset.globalHideDisplay) {
      el.dataset.globalHideDisplay = el.style.display || ''
    }
    el.style.display = 'none'
  } else if (el.dataset.globalHideDisplay !== undefined) {
    el.style.display = el.dataset.globalHideDisplay || ''
    delete el.dataset.globalHideDisplay
  }
}

// 海外站隐藏指令
const initGlobalHide = (app: App<Element>) => {
  app.directive('global-hide', {
    mounted(el: HTMLElement, binding: DirectiveBinding<boolean>) {
      toggleGlobalHidden(el, binding)
    },
    updated(el: HTMLElement, binding: DirectiveBinding<boolean>) {
      toggleGlobalHidden(el, binding)
    },
  })
}

export default {
  install(app: App<Element>) {
    initThrottle(app)
    initGlobalHide(app)
  },
}
